<template>
  <div class="participant-header-column field-col">
    <div class="content" @click="handleClick">
      <div class="caption-text">{{headerObject.displayName}}</div>
      <div class="icon-sort" v-if="showIcon" :class="[getIconClassName]"></div>
    </div>
  </div>
</template>

<script>
  // import routerConstants from '@/router/constants';

  export default {
    name: 'c-header-column',
    props: {
      headerObject: {
        type: Object,
        required: true
      },
      sortObject: {
        type: Object,
        required: true
      },
      showIcon: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        urlConsts: ''
      };
    },
    methods: {
      handleClick () {
        let sortOption = {
          fieldName: this.headerObject.internalName
        };
        this.$emit('CHANGE_SORT_OPTION', sortOption);
      }
    },
    computed: {
      getIconSort () {
        let iconName = 'sort-solid.svg';
        if (this.sortObject.fieldName === this.headerObject.internalName) {
          iconName = this.sortObject.reverse ? 'sort-up-solid.svg' : 'sort-down-solid.svg';
        }
        return `url('/static/images/${iconName}') no-repeat center`;
      },
      getIconClassName () {
        let className = 'non-sort';
        if (this.sortObject.fieldName === this.headerObject.internalName) {
          className = this.sortObject.reverse ? 'sort-up' : 'sort-down';
        }
        return className;
      }
    }
  };
</script>




// WEBPACK FOOTER //
// HeaderColumn.vue?b1b34d48